import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CTABanner } from './CTABanner';
import { CookieBanner } from './CookieBanner';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main id="main-content" className="flex-1">
        {children}
      </main>
      <CTABanner />
      <Footer />
      <CookieBanner />
    </div>
  );
}
